import './polyfills'

import React from 'react'
import { render } from 'react-dom'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import { AppContainer as HotEnabler } from 'react-hot-loader'
import configureStore from './store'
import storage from 'local-storage-fallback'
import Root from './root'
import ErrorTracking from './error-tracking'

import { Tabs } from 'react-tabs'
Tabs.setUseDefaultStyles(false)

import './styles/style.styl'
import 'react-select/dist/react-select.css'

ErrorTracking.begin()

const initialState = (() => {
  if (!!storage.getItem('type') === true &&
    !!storage.getItem('token') === true &&
    !!storage.getItem('email') === true &&
    !!storage.getItem('userName') === true &&
    !!storage.getItem('hasAcceptedTerms') === true &&
    !!storage.getItem('locationIds') === true &&
    !!storage.getItem('id') === true) {

    const user = {
      id: storage.getItem('id'),
      email: storage.getItem('email'),
      name: storage.getItem('userName'),
      type: storage.getItem('type')
    }

    ErrorTracking.setUser(user)

    return {
      auth: {
        session: {
          type: storage.getItem('type'),
          token: storage.getItem('token'),
          email: storage.getItem('email'),
          userName: storage.getItem('userName'),
          hasAcceptedTerms: (storage.getItem('hasAcceptedTerms').toLowerCase() == 'true'),
          locationIds: JSON.parse(storage.getItem('locationIds')),
          id: storage.getItem('id')
        },
        unreadNotification: {
          inProgress: 0,
          issue: 0
        }
      }
    }
  } else if (
    !!window.sessionStorage.getItem('type') === true &&
    !!window.sessionStorage.getItem('token') === true &&
    !!window.sessionStorage.getItem('email') === true &&
    !!window.sessionStorage.getItem('userName') === true &&
    !!window.sessionStorage.getItem('hasAcceptedTerms') === true &&
    !!window.sessionStorage.getItem('locationIds') === true &&
    !!window.sessionStorage.getItem('id') === true) {

    const user = {
      id: window.sessionStorage.getItem('id'),
      email: window.sessionStorage.getItem('email'),
      name: window.sessionStorage.getItem('userName'),
      type: window.sessionStorage.getItem('type')
    }

    ErrorTracking.setUser(user)

    return {
      auth: {
        session: {
          type: window.sessionStorage.getItem('type'),
          token: window.sessionStorage.getItem('token'),
          email: window.sessionStorage.getItem('email'),
          userName: window.sessionStorage.getItem('userName'),
          hasAcceptedTerms: (window.sessionStorage.getItem('hasAcceptedTerms').toLowerCase() == 'true'),
          locationIds: JSON.parse(window.sessionStorage.getItem('locationIds')),
          id: window.sessionStorage.getItem('id')
        },
        unreadNotification: {
          inProgress: 0,
          issue: 0
        }
      }
    }
  } else {
    return {}
  }
})()

const store = configureStore(initialState)
const history = syncHistoryWithStore(browserHistory, store)

const withHot = (
  <HotEnabler>
    <Root {...{ store, history }} />
  </HotEnabler>
)

render(withHot, document.getElementById('app'))

if (module.hot) {
  module.hot.accept('./root', () => {
    var Root = require('./root')
    render(
      <HotEnabler>
        <Root {...{ store, history }} />
      </HotEnabler>,
      document.getElementById('app')
    )
  })
}



// WEBPACK FOOTER //
// ./src/maats.js